import React, { Component } from 'react';
import { View, StyleSheet, Text, Pressable } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { OPComponent, OPPureComponent, I18n, Avatar, ProfileAvatar } from '../components';

import CaseSearchPaginated from './case_search_paginated';

class ItemSeparator extends Component {
  render() {
    return <View style={styles.itemSeparator} />;
  }
}

class DisplayCase extends OPPureComponent {
  selectItem = () => {
    const props = this.props;
    props.onPress(props.case.caseId);
  };
  render() {
    const props = this.props;
    const c = this.props.case;
    const patient = this.props.patient;
    if (!c) return null;

    const rank = patient?.rank;
    const group = c?.group;

    return (
      <Pressable onPress={this.selectItem}>
        <View style={[styles.selectedCaseContainer, props.containerStyle]} key={c.caseId}>
          {!!props.patientProfile?.avatarUrl ? (
            <ProfileAvatar profile={props.patientProfile} circleStyles={styles.caseAvatarStyle} />
          ) : (
            <Avatar
              initialsStr={c.name}
              onPress={null}
              attachment={c.avatar}
              circleStyles={styles.caseAvatarStyle}
            />
          )}

          <View style={styles.caseTextContainer}>
            <Text style={styles.caseNameText}>{c.name}</Text>
            <Text style={styles.caseDetailText}>{rank}</Text>
            <Text style={styles.caseDetailText}>{group}</Text>
          </View>
          {props.children}
        </View>
      </Pressable>
    );
  }
}

export default class CaseSearchList extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderItem = ({ item }) => {
    if (!item || !item.id) return null;

    return (
      <DisplayCase case={item.item} patient={item.item.patient} onPress={this.props.onSelectCase} />
    );
  };

  render() {
    const props = this.props;

    return (
      <View style={THEME.container}>
        <CaseSearchPaginated
          autoLoadOnScroll={true}
          employerId={props.employerId}
          searchLabel={props.searchLabel || I18n.ac_aec('case.findResident')}
          renderItem={this.renderItem}
          ItemSeparatorComponent={ItemSeparator}
          filters={props.filters}
          styleOverrides={{}}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  itemSeparator: {
    height: 2,
    backgroundColor: COLOR.altContrast,
  },
  selectedCaseContainer: {
    ...THEME.basicRow,
    backgroundColor: COLOR.altContrast,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderBottomColor: COLOR.accent,
    borderBottomWidth: 1,
  },
  caseTextContainer: {
    flex: 1,
    marginLeft: 15,
  },
  caseNameText: {
    ...FONT.bold,
    color: COLOR.text,
    fontSize: 14,
  },
  caseDetailText: {
    ...FONT.regular,
    color: COLOR.text,
    fontSize: 14,
    paddingTop: 5,
  },
  caseDetailTextThick: {
    ...FONT.medium,
    color: COLOR.text,
    fontSize: 14,
    paddingTop: 8,
  },
  caseDetailTextSmall: {
    ...FONT.medium,
    color: COLOR.text,
    fontSize: 12,
    paddingTop: 3,
  },
  caseAvatarStyle: {
    width: 50,
    height: 50,
  },
});
